export default     {
    prompt:"Episode Text?",
    field:"episodeColor",
    type:"childStyle",
    child:".short-cont",
    valueType:"string",
    colorPicker:true,
    default:"inherit",
    property:"color"
}